import { render, staticRenderFns } from "./screent_center.vue?vue&type=template&id=ad7d3146&scoped=true"
import script from "./screent_center.vue?vue&type=script&lang=js"
export * from "./screent_center.vue?vue&type=script&lang=js"
import style0 from "./screent_center.vue?vue&type=style&index=0&id=ad7d3146&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7d3146",
  null
  
)

export default component.exports